import { IBaasSignup } from '../../services/BaasSignupService';
import { getParameterByName } from '../../utils/WindowHelper';
import { isEmail, isHatName } from '../../utils/Validations';

export const signupBaasFromQuery: () => IBaasSignup = () => {
  const hatName = getParameterByName('hat_name');
  const email = getParameterByName('email');
  const appId = getParameterByName('application_id');
  const redirect = getParameterByName('redirect_uri');

  const optins = getParameterByName('newsletter_optin');

  if (hatName && isHatName(hatName) && email && isEmail(email) && appId && redirect) {
    return {
      email,
      hatName,
      applicationId: appId,
      redirectUri: redirect,
      newsletterOptin: optins === 'true',
    };
  } else {
    let errorMsg = '';
    if (!email) {
      errorMsg = 'email_is_required';
    } else if (!isEmail(email)) {
      errorMsg = 'email_is_not_valid';
    } else if (!hatName) {
      errorMsg = 'hat_name_is_required';
    } else if (!isHatName(hatName)) {
      errorMsg = 'hat_name_is_not_valid';
    } else if (!appId) {
      errorMsg = 'application_id_is_required';
    } else if (!redirect) {
      errorMsg = 'redirect_uri_is_required';
    } else {
      errorMsg = 'Unable to read all of the required query parameters';
    }
    throw Error(errorMsg);
  }
};
